/* eslint-disable import/prefer-default-export */
import cloneDeep from 'lodash.clonedeep';
import {
  FormTemplate,
  FormTemplateOption,
  FormTemplateSection,
  FormTemplateValidation,
} from 'data/template/template.types';
import { DeliveryFunctionNetworkInterface } from 'data/deliveryFunctionNetworkInterface/deliveryFunctionNetworkInterface.types';

export type ListenersIpAddressPortsType = {
  [key:string]: string[],
}

export function adaptTemplateVisibilityMode(
  template: FormTemplate | undefined,
  mode:'edit' | 'view',
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  if (mode === 'view') {
    setAllFieldsAsReadOnlyExcludingFields(clonedTemplate, []);
  }

  return clonedTemplate;
}

export function adaptTemplateOptions(
  template: FormTemplate | undefined,
  dfnInterfaces: DeliveryFunctionNetworkInterface[],
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);
  (clonedTemplate.sipInfo as FormTemplateSection).fields.niid.options = getDFNIOptions(dfnInterfaces);
  (clonedTemplate.sipInfo as FormTemplateSection).fields.niid.initial = dfnInterfaces?.[0]?.niid?.toString();

  clonedTemplate.formId = Date.now().toString();
  return clonedTemplate;
}

function getDFNIOptions(
  dfnInterfaces: DeliveryFunctionNetworkInterface[],
): FormTemplateOption[] {
  return dfnInterfaces?.map((entry) => ({
    label: `${entry.interface}:${entry.ipaddr}`,
    value: entry.niid.toString(),
  }));
}

function setAllFieldsAsReadOnlyExcludingFields(template: FormTemplate, excludingFields: string[]) {
  Object.entries(template).forEach(([_templateKey, templateEntry]) => {
    if (typeof templateEntry === 'string') {
      return;
    }
    Object.entries(templateEntry.fields).forEach(([fieldKey, fieldEntry]) => {
      if (!excludingFields.includes(fieldKey)) {
        fieldEntry.readOnly = true;
      }
    });
  });
}

export function adaptTemplateFieldChanges(
  template: FormTemplate,
  fieldName: string,
  value: string,
  ): FormTemplate {

  const clonedTemplate = cloneDeep(template);

  if (fieldName === 'encryptPani' && (clonedTemplate?.sipInfo as FormTemplateSection)?.fields?.encryptKey?.validation != null) {
    ((clonedTemplate.sipInfo as FormTemplateSection).fields.encryptKey.validation as FormTemplateValidation).required = value === 'DESECB';
    clonedTemplate.formId = Date.now().toString();
  }

  return clonedTemplate;
}
